// "Do this when the phone has a spare moment."
//
// Game Lite does its warming (route chunks, the next wine's questions) off the
// critical path: the screen the player is looking at always gets the network
// and the main thread first. `requestIdleCallback` is the right primitive for
// that, and Safari still doesn't have it — hence the timer fallback rather than
// a bare call that would throw on iOS.

const IDLE_TIMEOUT_MS = 1500;
// Long enough that the current screen's own fetches are away first, short
// enough that a player who taps straight through still benefits.
const FALLBACK_DELAY_MS = 250;

/**
 * Run `fn` once the browser is idle.
 *
 * @param {() => void} fn
 * @returns {() => void} cancel — safe to call after it has already run.
 */
export function onIdle(fn) {
  if (typeof window === 'undefined') return () => {};

  if (typeof window.requestIdleCallback === 'function') {
    const handle = window.requestIdleCallback(fn, { timeout: IDLE_TIMEOUT_MS });
    return () => window.cancelIdleCallback?.(handle);
  }

  const handle = window.setTimeout(fn, FALLBACK_DELAY_MS);
  return () => window.clearTimeout(handle);
}
